"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const colors_1 = require("../../utilities/colors");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const Dropdown = _ref => {
  let {
    options,
    onChange,
    parser = v => v,
    value,
    color,
    label
  } = _ref;
  const asSelect = options.length > 1;
  return react_1.default.createElement("span", {
    className: `${styles_module_css_1.default['dropdown-wrapper']} ${styles_module_css_1.default[asSelect && 'as-select']}`,
    style: {
      color: (0, colors_1.parseColor)(color, '')
    }
  }, label && react_1.default.createElement("span", {
    className: styles_module_css_1.default['dropdown-spacer']
  }, label), asSelect ? react_1.default.createElement("select", {
    className: styles_module_css_1.default['dropdown-select'],
    onChange: onChange,
    value: parser(value)
  }, options.map(option => {
    const parsed = parser(option);
    return react_1.default.createElement("option", {
      key: parsed
    }, parsed);
  })) : react_1.default.createElement("span", {
    className: styles_module_css_1.default['dropdown-single']
  }, parser(options[0])));
};
Dropdown.propTypes = {
  /**
   * Array of selectable options for the dropdown
   */
  options: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string])),
  /**
   * Function to execute when a selection is made
   */
  onChange: prop_types_1.func.isRequired,
  /**
   * Function to determine key and what is shown in dropdown
   * Default: v => v
   */
  parser: prop_types_1.func,
  /**
   * Current value to set for the dropdown. First item selected if not set.
   */
  value: prop_types_1.string,
  /*
   * Color to show text in
   */
  color: prop_types_1.string,
  /*
   * Label to be shwon
   */
  label: prop_types_1.string
};
exports.default = Dropdown;